import React, { ForwardRefRenderFunction, forwardRef } from "react";
//#region types
import { InvoiceEditDueFormContainerProps } from "models/propTypes/invoicePropTypes";
import { FormHandles } from "models/propTypes/genericFormProps";
import { InvoiceFormTypes } from "models/formTypes";
import { TranslationKeys } from "translations";
//#endregion
//#region components
import InvoiceEditDueForm from "./editDueForm";
import { useInvoiceService } from "serviceHooks";
//#endregion
import * as Yup from "yup";

const InvoiceEditDueFormContainer: ForwardRefRenderFunction<FormHandles, InvoiceEditDueFormContainerProps> = (
  props,
  ref
) => {
  const invoiceService = useInvoiceService();
  const initialValues = React.useMemo(
    () => ({
      dueDate: props.reminderDueDate ?? props.dueDate,
    }),
    []
  );

  const handleSubmit = React.useCallback(
    (values: InvoiceFormTypes.EditDueDate) => {
      return invoiceService.editDueDate(props.invoiceId, {
        dueDate: values.dueDate,
      });
    },
    [props.invoiceId]
  );

  return (
    <InvoiceEditDueForm
      ref={ref}
      {...props}
      validationSchema={Yup.object<InvoiceFormTypes.EditDueDate>({
        dueDate: Yup.date()
          .min(props.invoiceDate, TranslationKeys.Validations.InvoiceDueDateGreaterThanInvoiceDate)
          .required(TranslationKeys.Validations.Required)
          .typeError(TranslationKeys.Validations.InvalidDate),
      })}
      defaultValues={initialValues}
      handleSubmit={handleSubmit}
    />
  );
};

export default forwardRef(InvoiceEditDueFormContainer);
